'use client'

import { Button } from "@/components/ui/button"
import Link from "next/link"

export default function RulesPage() {
  return (
    <div className="min-h-[calc(100vh-100px)] px-3 pb-20 pt-6 sm:px-4">
      <div className="mx-auto w-full max-w-6xl">
        <section className="overflow-hidden rounded-lg bg-[var(--rtbf-blue-dark,#003E63)] text-white">
          <div className="space-y-6 p-4 md:p-6">
            <div>
              <h1 className="mb-2 text-xl font-bold text-white">Règles du jeu Prono CDM</h1>
              <p className="text-md text-white/90">
                Bienvenue dans le jeu de pronostics Coupe du Monde de la RTBF !
              </p>
            </div>
            <div className="space-y-4">
          <p className="text-white/90">Les règles du jeu sont simples :</p>
          <ul className="list-disc list-inside space-y-1">
            <li>Connectez-vous avec votre profil RTBF</li>
            <li>Pronostiquez le score exact de tous les matchs</li>
            <li>Gagnez un maximum de points avec des pronostics corrects</li>
            <li>Battez vos amis, votre famille et vos collègues</li>
          </ul>

          <h3 className="text-xl font-semibold mb-2">Système de points</h3>
          <p className="mb-4">Pour chaque match, vous pouvez marquer des points de différentes manières :</p>
          <p className="mb-2 font-semibold">Résultat correct</p>
          <ul className="mb-3 space-y-2">
            <li className="list-none bg-white/95 text-[var(--rtbf-blue-dark,#003E63)] border-l-4 border-[var(--rtbf-orange,#fdc300)] rounded-r-md px-4 py-3 font-semibold flex items-center justify-between gap-3">
              <span>Prédire correctement le vainqueur ou prédire correctement un match nul</span>
              <span className="shrink-0 rounded-full bg-[#dcebf8] text-[#2c63a4] px-3 py-1 text-sm font-semibold">+3 points</span>
            </li>
          </ul>
          <p className="mb-4 italic">
            Le résultat est déterminé à la fin du temps de jeu, c&apos;est-à-dire après 90 minutes, ou après 120 minutes si le match va en prolongation.
            Les matchs décidés aux tirs au but sont comptés comme un match nul.
          </p>
          <p className="mb-2 font-semibold">Score exact</p>
          <ul className="mb-6 space-y-2">
            <li className="list-none bg-white/95 text-[var(--rtbf-blue-dark,#003E63)] border-l-4 border-[var(--rtbf-orange,#fdc300)] rounded-r-md px-4 py-3 font-semibold flex items-center justify-between gap-3">
              <span>Prédire correctement le nombre de buts de l&apos;équipe à domicile</span>
              <span className="shrink-0 rounded-full bg-[#dcebf8] text-[#2c63a4] px-3 py-1 text-sm font-semibold">+1 point</span>
            </li>
            <li className="list-none bg-white/95 text-[var(--rtbf-blue-dark,#003E63)] border-l-4 border-[var(--rtbf-orange,#fdc300)] rounded-r-md px-4 py-3 font-semibold flex items-center justify-between gap-3">
              <span>Prédire correctement le nombre de buts de l&apos;équipe à l&apos;extérieur</span>
              <span className="shrink-0 rounded-full bg-[#dcebf8] text-[#2c63a4] px-3 py-1 text-sm font-semibold">+1 point</span>
            </li>
            <li className="list-none bg-white/95 text-[var(--rtbf-blue-dark,#003E63)] border-l-4 border-[var(--rtbf-orange,#fdc300)] rounded-r-md px-4 py-3 font-semibold flex items-center justify-between gap-3">
              <span>Prédire correctement la différence de buts entre les deux équipes</span>
              <span className="shrink-0 rounded-full bg-[#dcebf8] text-[#2c63a4] px-3 py-1 text-sm font-semibold">+1 point</span>
            </li>
          </ul>
          <p className="mb-8 italic">Les buts marqués lors des tirs au but ne comptent pas.</p>

          <h3 className="text-xl font-semibold mb-2">Compétitions</h3>
          <p className="mb-4">
            Vous pouvez créer ou rejoindre des ligues pour jouer contre vos amis, votre famille ou vos collègues. Il existe deux types de ligues :
          </p>
          <h4 className="text-lg font-semibold mb-1">Ligues publiques</h4>
          <p className="mb-4">
            Tout le monde peut trouver et rejoindre une ligue publique. Vous n&apos;avez pas besoin de code PIN pour y participer.
          </p>
          <h4 className="text-lg font-semibold mb-1">Ligues privées</h4>
          <p className="mb-4">
            Pour rejoindre une ligue privée, vous avez besoin du code PIN défini par le fondateur de la ligue. Créez une compétition privée et partagez ce code avec les personnes que vous voulez défier.
          </p>
          <p className="mb-8">Il n&apos;y a pas de limite au nombre de compétitions auxquelles vous pouvez participer.</p>

          <h3 className="text-xl font-semibold mb-2">Classements</h3>
          <p className="mb-4">
            Vous êtes automatiquement repris dans le classement général, avec tous les autres joueurs du monde entier.
          </p>

          <h3 className="text-xl font-semibold mb-2">Général</h3>
          <p className="mb-4">
            RTBF se réserve le droit de refuser des utilisateurs s&apos;ils ne respectent pas les règles du jeu ou s&apos;ils vont à l&apos;encontre de l&apos;esprit du jeu.
            En cas d&apos;abus, de tromperie ou de fraude (participation via un script, personnes fictives, adresses e-mail fictives, exploitation d&apos;un bug, etc.),
            RTBF peut supprimer un utilisateur et/ou ses équipes et lui retirer le droit à toute récompense éventuelle.
          </p>

            <div className="pt-4 text-center">
              <Button asChild className="rounded-full bg-[var(--rtbf-orange,#fdc300)] text-[var(--rtbf-blue-dark,#003E63)] hover:bg-[#e6b200]">
                <Link href="/fantasy/predictions">Retour à Prono</Link>
              </Button>
            </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}
